/**
 * @return {string} apple-touch-icon link source
 */
export function linkAppleTouchIcon() {
  const link = document.querySelector('link[rel="apple-touch-icon"]');
  return link ? link.href : "";
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/helpers/icon.js
// module id = 793
// module chunks = 1